const isDemoEnabled = () => localStorage.getItem("demoAccount")?true:false;
export default isDemoEnabled;